import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViewSelectedClientsComponent } from './view-selected-clients/view-selected-clients.component';
import { MatIconModule } from '@angular/material/icon';
import { ChipsModule } from 'primeng/chips';
import { ComponentsModule } from 'projects/access-control/src/app/UI/components/component.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { loadingSpinnerModule } from 'projects/access-control/src/app/UI/commons/loading-spinner/loading-spinner.module';
import { ViewDeployConfigComponent } from './view-deploy-config/view-deploy-config.component';
import { DirectivesModule } from 'projects/access-control/src/app/Infrastructure/directive/directives.module';
import { MatChipsModule } from '@angular/material/chips';
import { CommonsModule } from 'projects/access-control/src/app/UI/commons/commons.module';
import { NgxCodejarModule } from 'ngx-codejar';
import { S3UploadModule } from '@mangosoft/mango-layout';

@NgModule({
	declarations: [ViewSelectedClientsComponent, ViewDeployConfigComponent],
	exports: [ViewSelectedClientsComponent, ViewDeployConfigComponent],
	imports: [
		CommonModule,
		MatIconModule,
		ChipsModule,
		loadingSpinnerModule,
		ComponentsModule,
		NgxCodejarModule,
		CommonsModule,
		MatChipsModule,
		ReactiveFormsModule,
		FormsModule,
		S3UploadModule,
		DirectivesModule,
	],
})
export class ComponentsClientModule {}
